import { MapModel } from "./mapModel";

/**
 * Třída shromažďující nastavení mapy
 */
export class MapSettings {
	/** úvodní úroveň přiblížení */
	initialZoom: number;

	/** zobrazit zastávky */
	showStops: boolean = false;

	/** udává, zda je mapa zrovna v pohybu */
	isBlocked = false;

	/** zobrazení konkrétního spoje */
	singleConnectionViewMode: boolean = false;

	/** zobrazení konkrétní zastávky */
  singleStopViewMode: boolean = false;

  /** zobrazit značky v mapě s číslem spoje */
  detailed: boolean = false;

  /** zobrazit značky v mapě s číslem spoje a odkud kam jede */
  extraDetailed: boolean = false;

	constructor(data: MapModel) {
		this.initialZoom = data.initialZoom ?? 10;
	}
}
